interface ToggleProps {
  value: boolean;
  onChange: () => void;
  size?: "sm" | "md";
  showLabel?: boolean;
  disabled?: boolean;
}

export function Toggle({ value, onChange, size = "md", showLabel = false, disabled = false }: ToggleProps) {
  const sm = size === "sm";
  return (
    <div className="flex items-center gap-2">
      {showLabel && (
        <span className={`text-xs font-medium transition-colors ${value ? "text-primary" : "text-muted-foreground"}`}>
          {value ? "Attivo" : "Inattivo"}
        </span>
      )}
      <button
        type="button"
        role="switch"
        aria-checked={value}
        disabled={disabled}
        onClick={onChange}
        className={[
          "relative flex-shrink-0 rounded-full transition-colors duration-200",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          sm ? "w-8 h-4" : "w-11 h-6",
          value ? "bg-primary" : "bg-muted-foreground/30",
        ].join(" ")}
      >
        <span
          className={[
            "absolute bg-card rounded-full shadow-sm transition-all duration-200",
            sm
              ? `w-3 h-3 top-0.5 ${value ? "left-[18px]" : "left-0.5"}`
              : `w-4 h-4 top-1 ${value ? "left-6" : "left-1"}`,
          ].join(" ")}
        />
      </button>
    </div>
  );
}
